import * as Sentry from '@sentry/browser'
import {
	DependentSelectBoxComponent,
	DropDown,
	DropdownMenu,
	GridStack,
	Loader,
	PaginatorComponent,
	Scroller,
	SwiperComponent,
	TabComponent,
} from 'component'
import { autoTopPaddingHelper, payloadHelper } from 'helper'
import * as ReactComponents from '@/react-components'
import { Events } from './events'
import { Modules } from './modules'

type InitMainModulesProps = {
	isAjax?: boolean
	initPopups?: boolean
	showModalOverview?: boolean
}

export const Setup = () => {
	const initReactComponents = () => {
		ReactComponents.ReactSelectComponent.init()
		ReactComponents.ReactTooltipSelectComponent.init()
		ReactComponents.ReactDatetimeComponent.init()
		ReactComponents.ReactDatatableComponent.init()
		ReactComponents.ConditionBuilderComponent.init()
		ReactComponents.SignificationTable.init()
	}

	const initMainModules = (props?: InitMainModulesProps) => {
		const isAjax = props?.isAjax === true

		Modules.admin.init()
		Modules.alertDashboard.init(props && props.isAjax)
		Modules.alertDetail.init()
		Modules.alertAppeal.init()
		Modules.blockHelps.init()
		Modules.creator.init(props && props.showModalOverview, isAjax)
		Modules.editor.init(isAjax)
		Modules.crossTable.init()
		Modules.drawer.init()
		Modules.fileManager.init()
		Modules.filter.init(isAjax)
		if (!isAjax) Modules.header.init({ shouldScrolledModifier: false })
		Modules.menu.init()
		Modules.tracking.init(isAjax)
		Modules.feedbackDetail.init()
		Modules.passwordManager.init()
		Modules.feedbackMessengerWindow.init()
		Modules.stickyBlock.init(isAjax)
		Modules.pdfExport.init()
		Modules.actionPlanner.init()

		try {
			Modules.dataGrid.init()
		} catch (e) {
			console.log(e)
		}
	}

	const initComponents = (isAjax = false, payload = null) => {
		DropDown.init(onShownForDropdown)
		TabComponent.init()
		DropdownMenu.init()
		PaginatorComponent.init()
		DependentSelectBoxComponent.init(isAjax, payload)
		Loader.init()
		Scroller.init()
	}

	const initSentry = () => {
		Sentry.init({
			dsn: window.appConfig.environments.SENTRY_DSN,
			replaysSessionSampleRate: parseFloat(window.appConfig.environments.SENTRY_REPLAYS_SESSION_SAMPLE_RATE),
			replaysOnErrorSampleRate: parseFloat(window.appConfig.environments.SENTRY_REPLAYS_ERROR_SAMPLE_RATE),
			integrations: [Sentry.replayIntegration()],
		})
	}

	const handleAjaxComplete = async (payload: any) => {
		GridStack.init({ enableResizing: payload && payload.enableGridStackResizing })
		const initPopups = !!payload.initPopups
		const showModalOverview = !!payload.showModalOverview
		initMainModules({ isAjax: true, initPopups, showModalOverview })
		initComponents(true, payload)
		initReactComponents()

		if (payloadHelper.HideLoader(payload)) {
			Loader.hideMain()
		}

		if (payloadHelper.ExistUrl(payload)) {
			window.history.pushState('', '', payload.url)
		}

		if (payloadHelper.ReinitCarousel(payload)) {
			setTimeout(() => {
				Modules.tracking.init()
			}, 200)
		}

		if (payloadHelper.TriggerCampaignChange(payload)) {
			Modules.tracking.triggerCampaignSelectChange()
		}
		DropDown.init(onShownForDropdown)

		if (payloadHelper.ExistRedrawCharts(payload)) {
			Modules.charts.updateRemovedBlocks(payload)
			await Modules.charts.init()
			Modules.figures.resize()
		}

		GridStack.resizeToContent()
		Modules.abstractResizer.init({})
		Modules.abstractResizer.destroyLoading()
	}

	const onShownForDropdown = (): void => {
		// @ts-ignore
		$.nette.load() // to reinit ajax after render content
		Modules.pdfExport.init()
	}

	const handleBeforeAjaxConfirm = (_: any, settings: any) => {
		if (!settings.nette) {
			return null
		}
		const question = settings.nette.el.data('confirm')
		if (question) {
			// eslint-disable-next-line no-restricted-globals,no-undef,no-alert
			return confirm(question)
		}
		return null
	}

	const handleDOMLoad = async () => {
		GridStack.init({ enableResizing: false })
		initSentry()
		initMainModules()
		initComponents()
		initReactComponents()
		Modules.figures.resize()
		await Modules.charts.init()
		SwiperComponent.init()
		GridStack.resizeToContent()
		Modules.abstractResizer.init({})
		Modules.abstractResizer.destroyLoading()
		Events().onResizeWindow(async () => {
			await Modules.charts.update()
			Modules.figures.resize()
		})
	}

	// eslint-disable-next-line @typescript-eslint/no-empty-function
	const handleLoad = () => {}

	// eslint-disable-next-line @typescript-eslint/no-empty-function
	const handleNetteExtLoad = () => {}

	const handleResizeWindow = () => {
		autoTopPaddingHelper.calculateTopPaddingFilter()
	}

	const apply = () => {
		const events = Events()
		events.onAjaxComplete(handleAjaxComplete)
		events.onBeforeAjaxConfirm(handleBeforeAjaxConfirm)
		events.onDOMLoad(handleDOMLoad)
		events.onLoad(handleLoad)
		events.onNetteExtLoad(handleNetteExtLoad)
		events.onResizeWindow(handleResizeWindow)
	}

	return {
		apply,
	}
}
